var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBellEmpty(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 29,
    viewBox: "0 0 24 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 25.0977C15.595 25.8888 15.012 26.546 14.3098 27.0028C13.6076 27.4596 12.811 27.7002 12 27.7002C11.189 27.7002 10.3924 27.4596 9.69017 27.0028C8.98798 26.546 8.40504 25.8888 8 25.0977",
    stroke: "#404040",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23 23.1697H1C2.16197 20.7126 2.69256 17.9838 2.54 15.2496L2.41429 13.0764C2.24995 10.8285 2.68499 8.57702 3.67143 6.57022C5.41257 3.19929 8.49886 1 11.9686 1C15.4383 1 18.5246 3.19929 20.2657 6.57022C21.2522 8.57702 21.6872 10.8285 21.5229 13.0764L21.4034 15.184C21.246 17.939 21.7743 20.6897 22.9371 23.1697H23Z",
    stroke: "#404040",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellEmpty);
export default __webpack_public_path__ + "static/media/bell-empty.5544020f76aa2e651f473a5f668546ce.svg";
export { ForwardRef as ReactComponent };